import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { PrimaryOutlineButton } from 'src/components/button';
import Checkbox from '@material-ui/core/Checkbox';
import theme from 'shared/theme';
import Alert from '@material-ui/lab/Alert';

import { TermsAndConditions } from './content';

const DATA_TEST_PRE = 'term-condition-modal-';
export default function TermsAndConditionsModal(props) {
  const [checked, setChecked] = useState(false);
  const [alertOpen, setalertOpen] = useState(false);
  const { open, submit, title } = props;
  const onSubmit = () => {
    if (checked) {
      if (alertOpen) {
        setalertOpen(false);
      }
      submit();
    } else {
      setalertOpen(true);
    }
  };
  const useStyles = makeStyles({
    modalStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalBody: {
      width: '610px',
      background: '#fff',
      borderRadius: '10px',
      position: 'relative',
      '@media (max-width:780px)': {
        width: '88%',
      },
    },
    closeButton: {
      float: 'right',
      cursor: 'pointer',
      position: 'absolute',
      right: '20px',
      top: '20px',
    },
    caption: {
      fontSize: '24px',
      textAlign: 'center',
      fontWeight: 'bold',
      marginTop: '40px',
      '@media (max-width:780px)': {
        fontSize: '16px',
      },
    },
    modalContent: {
      padding: '0 35px',
      '@media (max-width:780px)': {
        padding: '0 18px',
      },
    },
    actionButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '20px 0 40px',
    },
    modalInnerContent: {
      height: '330px',
      overflow: 'scroll',
      border: `solid 1px ${theme.community.paleGrey}`,
      marginTop: '20px',
      padding: '20px',
      borderRadius: '4px',
      color: theme.community.stone,
    },
  });

  const handleChange = event => {
    setChecked(event.target.checked);
  };
  const classes = useStyles();
  return (
    <Modal
      className={classes.modalStyle}
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.modalBody}>
        {alertOpen ? (
          <Alert variant="filled" severity="error">
            Please agree to the terms before accessing the community.
          </Alert>
        ) : null}
        <div className={classes.modalContent}>
          <div
            className={classes.caption}
            data-testid={`${DATA_TEST_PRE}title`}
          >
            {title}
          </div>
          <div className={classes.modalInnerContent}>
            <div dangerouslySetInnerHTML={{ __html: TermsAndConditions() }} />
          </div>
          <div style={{ marginTop: '10px', color: theme.community.stone }}>
            <Checkbox
              checked={checked}
              style={{ color: '#00a796' }}
              onChange={handleChange}
              data-testid={`${DATA_TEST_PRE}check`}
            />
            I have read the terms and conditions
          </div>
        </div>

        <div className={classes.actionButton}>
          <PrimaryOutlineButton
            onClick={onSubmit}
            data-testid={`${DATA_TEST_PRE}accept`}
          >
            Accept
          </PrimaryOutlineButton>
        </div>
      </div>
    </Modal>
  );
}
